export default __webpack_public_path__ + "static/media/default-profile-icon.54b3a769.jpg";